



















import {Kunde} from "@/models/kunde-model";
import {Vue, Prop, Component} from "vue-property-decorator";

@Component
export default class Zusatzfunktionen extends Vue {
    @Prop() header!: boolean;
    @Prop() field!: keyof(Kunde);
    @Prop() kunde!: Kunde;
    @Prop() titleKey?: string;
    @Prop() textKey?: string;

    private set() {
        this.kunde[this.field] = true as never;
    }
    private unset() {
        this.kunde[this.field] = false as never;
    }
}
